import { Inbox, Loader2 } from "lucide-react";

export function PageHeader({ title, desc, action }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tighter">{title}</h1>
        {desc && <p className="mt-1 text-sm text-muted-foreground">{desc}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ title, desc, icon: Icon = Inbox, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border py-16 text-center" data-testid="empty-state">
      <span className="grid h-14 w-14 place-items-center rounded-2xl bg-muted text-muted-foreground">
        <Icon size={26} strokeWidth={1.5} />
      </span>
      <h3 className="mt-4 text-base font-bold">{title}</h3>
      {desc && <p className="mt-1 text-sm text-muted-foreground max-w-sm">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex justify-center py-20">
      <Loader2 className="animate-spin text-primary" size={28} />
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-border bg-card ${className}`}>{children}</div>;
}
